import request from '../_network/request'

const getCategory = (loc) => {
    return request({
        url: `/weblayer/template/api,POSAPI.vm?cmd=2&type=kat&loc=` + loc,
        method: 'GET'
    })
}

const getItem = (loc, id) => {
    return request({
        url: `/weblayer/template/api,POSAPI.vm?cmd=2&type=item&loc=` + loc + '&katid=' + id,
        method: 'GET',
        headers: {
            'Content-Type' : 'application/json'
        }
    })
}

const getTenant = () => {
    return request({
        url: `/weblayer/template/api,POSAPI.vm?cmd=0`,
        method: 'GET'
    })
}

export const home = {
    getCategory,
    getItem,
    getTenant
}
